import styled from "styled-components";
export const PseudoWrapper = styled.div `
  bottom: calc(100% + 12px);
  display: block;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  z-index: 999;
  &:after {
    border-radius: 12px;
    box-shadow: 0px 4px 4px 0px #dce0f1;
    content: "";
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
  &:before {
    background: ${({ theme }) => theme.color.ui7};
    bottom: -8px;
    box-shadow: 0px 2px 14px 0px #dce0f1;
    content: "";
    height: 16px;
    left: calc(50% - 8px);
    position: absolute;
    transform: rotate(45deg);
    width: 16px;
    z-index: 998;
  }
`;
export const Popup = styled.div `
  background: ${({ theme }) => theme.color.ui7};
  border-radius: 12px;
  display: block;
  padding: 10px 10px 15px 10px;
  position: relative;
  z-index: 998;
`;
